import { render, staticRenderFns } from "./BillPos.vue?vue&type=template&id=c224570a&scoped=true&"
import script from "./BillPos.vue?vue&type=script&lang=js&"
export * from "./BillPos.vue?vue&type=script&lang=js&"
import style0 from "./BillPos.vue?vue&type=style&index=0&id=c224570a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c224570a",
  null
  
)

export default component.exports